export const USER_ROLES = {
  USER: "user",
  OWNER: "owner",
  ADMIN: "admin",
  GUEST: "guest",
};

export type USER_ROLE_TYPE = "user" | "owner" | "admin" | "guest";

export const GUEST_EMAIL = "guest@plugz.io";
